<template>
  <div class="graph as-flex main-center cross-center">
    <canvas class="graph-chart" ref="chart" id="myChart"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";
import { clone } from "lodash";
export default {
  name: "graph_chart",
  props: {
    graph_config: {},
    avg: {},
    indicator: {},
    offset: {}
  },
  data() {
    return {
      ctx: undefined,
      chart: undefined
    };
  },
  computed: {},
  methods: {
    computeAverageX(oneValue, oneX, baseX, averageValue) {
      return (averageValue * (oneX - baseX)) / oneValue + baseX;
    },
    isAverageMax(data) {
      let res = true;
      for (let i = 0; i < data.datasets[0].data.length; i++) {
        if (data.datasets[0].data[i] > this.avg[0][this.indicator]) {
          res = false;
          break;
        }
      }
      return res;
    },
    createCharts(data) {
      if (this.chart) {
        this.chart.destroy();
      }
      let isAverageMax = this.isAverageMax(data);
      let context = this;
      this.ctx = this.$refs["chart"];
      let options = {
        // The type of chart we want to create
        type: "horizontalBar",
        // The data for our dataset
        data: {
          labels: data.labels || [],
          datasets: data.datasets
        },
        // Configuration options go here
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 0,
              right: 35,
              top: 0,
              bottom: 30
            }
          },
          tooltips: {
            enabled: false,
            mode: "index",
            intersect: false,
            position: "nearest",
            xAlign: "center",
            yAlign: "center",
            titleFontSize: 8,
            bodyFontSize: 8,
            footerFontSize: 8
            // itemSort: (pre, cur) => {
            //   if (pre.yLabel >= cur.yLabel) {
            //     console.log(pre);
            //     return -1;
            //   } else {
            //     return 1;
            //   }
            // }
          },
          hover: {
            display: false
            // mode: "nearest",
            // intersect: true
          },
          legend: {
            display: false
          },
          scales: {
            yAxes: [
              {
                maxBarThickness: 10,
                display: true,
                scaleLabel: {
                  display: true
                },
                gridLines: {
                  color: "rgba(0, 0, 0, 0)", // 隐藏要y轴轴线
                  zeroLineColor: "#999999"
                },
                ticks: {
                  callback: function(value, index, values) {
                    if (value.length > 6) {
                      return value.slice(0, 6) + "..";
                    } else {
                      let diff = 6 - value.length;
                      for (let i = 0; i < diff; i++) {
                        value = `${value}`;
                      }
                      return value;
                    }
                  }
                }
                // afterFit: function(scaleInstance) {
                //   scaleInstance.width = 100; // sets the width to 100px
                //   // scaleInstance.width = 95;
                // }
              }
            ],
            xAxes: [
              {
                display: false,
                ticks: {
                  // max: isAverageMax ? context.avg[0][context.indicator] : ,
                  // max: isAverageMax ? context.avg[0][context.indicator] : ,
                  beginAtZero: true
                }
              }
            ]
          },
          animation: {
            onComplete: function() {
              let ctx = this.chart.ctx;
              // ctx.canvas -= 40
              ctx.font = Chart.helpers.fontString(
                Chart.defaults.global.defaultFontFamily,
                "normal",
                Chart.defaults.global.defaultFontFamily
              );
              ctx.fillStyle = "#666666";
              ctx.textAlign = "center";
              ctx.textBaseline = "center";

              this.data.datasets.forEach(function(dataset) {
                dataset.data.forEach(function(bar, index) {
                  let model =
                    dataset._meta[Object.keys(dataset._meta)[0]].data[index]
                      ._model;
                  ctx.fillText(`${bar}%`, model.x + 20, model.y + 3);
                });
              });
              //计算出均值所在x轴坐标
              let oneValue = this.data.datasets[0].data[0];
              let oneX = this.data.datasets[0]._meta[
                Object.keys(this.data.datasets[0]._meta)[0]
              ].data[0]._model.x;
              let baseX = this.data.datasets[0]._meta[
                Object.keys(this.data.datasets[0]._meta)[0]
              ].data[0]._model.base;
              let averageX = context.computeAverageX(
                oneValue,
                oneX,
                baseX,
                context.avg[0][context.indicator]
              );
              ctx.beginPath();
              ctx.lineWidth = "0.3";
              ctx.strokeStyle = "#999999";
              // if (averageX <= this.chartArea.right - 35) {
              // ctx.moveTo(averageX, this.chartArea.bottom);
              // ctx.lineTo(averageX, this.chartArea.top);
              ctx.drawDashLine(
                ctx,
                averageX,
                this.chartArea.top + 5,
                averageX,
                this.chartArea.bottom + 6,
                3
              );
              // } else {
              //   averageX = this.chart.width / 2;
              // }

              ctx.stroke(); // 进行绘制
              ctx.fillStyle = "#999999";
              ctx.textAlign = "center";
              ctx.textBaseline = "center";
              ctx.fillText(
                `总体均值${context.avg[0][context.indicator]}%(${
                  context.offset
                })`,
                averageX + 35 > this.chartArea.right ? averageX - 35 : averageX,
                this.chartArea.bottom + 20
              );
            }
          }
        }
      };
      if (isAverageMax) {
        options.options.scales.xAxes[0].ticks.max =
          context.avg[0][context.indicator];
      }
      this.chart = new Chart(this.ctx, options);
    }
  },
  watch: {
    graph_config: {
      handler: function(to, from) {
        if (this.chart) {
          this.chart.destroy();
        }
        this.createCharts(clone(to));
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.createCharts(clone(this.graph_config));
  },
  destroyed() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>

<style lang="scss" scoped>
.graph {
  width: 100%;
  height: 100%;
  position: relative;
}
.graph-chart {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>

